

























import {
  Component,
  Prop,
  Provide,
  Vue
} from 'vue-property-decorator';
import OrderTemplateSelection from '../common/OrderTemplateSelection.vue';
import DetailPurchaseSection from './DetailPurchaseSection.vue';
import { UnitDefinition } from '@/services/ProductDeserializer';
import { ConfigService } from '@/services/ConfigService';
import { BooleanService } from '@/services/util/BooleanService';
import { OrderTemplateDeserializer } from '@/services/OrderTemplateDeserializer';
import {OrderTemplateDto, ProductDto} from '../../../../../../hub-client-typescript/target/generated-client';
import MatomoContext from '@/matomo/domain/MatomoContext';

@Component({ components: { DetailPurchaseSection, OrderTemplateSelection } })
export default class DetailPurchaseAndOrderTemplateSection extends Vue {

  get orderTemplates(): OrderTemplateDto[] {
    return OrderTemplateDeserializer.parseOrderTemplateList(this.localOrderTemplates);
  }

  get simpleView(): boolean {
    return BooleanService.fromString(this.localSimpleView);
  }

  get availability(): ProductDto.AvailabilityEnum {
    switch (this.localAvailability) {
      case 'PRE_ORDER':
        return ProductDto.AvailabilityEnum.PREORDER;
      case 'NOT_DELIVERABLE':
        return ProductDto.AvailabilityEnum.NOTDELIVERABLE;
      case 'ACTIVE':
      default:
        return ProductDto.AvailabilityEnum.ACTIVE;
    }
  }

  @Prop({ required: true })
  public localSku: string;
  @Prop({ required: true })
  public localUnits: string;
  @Prop()
  public localBulkPrices: string;
  @Prop({ required: true })
  public localMinSaleQuantity: string;
  @Prop({ required: false, default: '' })
  public localOrderTemplates: string;
  @Prop({ required: false, default: 'true' })
  public localSimpleView: string;
  @Prop({ required: false, default: 'true'})
  public localShowOrderTemplates: string;
  @Prop({ required: false, default: 'ACTIVE' })
  public localAvailability: string;
  @Prop({required: false})
  public localShowConvenienceMessage: string;

  @Provide()
  public matomoContext = MatomoContext.forProductDetail();

  public currAmount = this.minSaleQuantity;
  public currUnit = this.defaultUnit;

  public onUnitChanged(newVal: UnitDefinition) {
    this.currUnit = newVal;
  }

  public onAmountChanged(newVal: number) {
    this.currAmount = newVal;
  }

  get showOrderTemplates(): boolean {
    return BooleanService.fromString(this.localShowOrderTemplates);
  }

  get minSaleQuantity(): number {
    const minSalesQuantity = Number.parseFloat(this.localMinSaleQuantity);
    return minSalesQuantity > 0 ? minSalesQuantity : 1;
  }

  get defaultUnit(): UnitDefinition {
    const units = ConfigService.parseUnits(this.localUnits);
    const unit = units.find((it) => it.isDefault);
    if (unit === undefined) {
      return units[0];
    }
    return unit;
  }
}

